import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Tooltip,
  Cascader,
  Select,
  Row,
  Col,
  Checkbox,
  Button,
  Card,
  AutoComplete,Table
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useFormDetail } from '../../../util/dataProvider';
import {NotificationContainer, NotificationManager} from "react-notifications";
const { Option } = Select;
const AutoCompleteOption = AutoComplete.Option;

  
  // rowSelection object indicates the need for row selection
  

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const Registration = () => {
  const [form] = Form.useForm();
  const {  loading,createSubject,success,setSuccess,getClassList,classList,createStationeryCat } = useFormDetail();

  useEffect (() => {
   if(success){
    //form.resetFields();
    NotificationManager.success('Book Saved Successfully', 'Success', 2000);
    setSuccess(false);
    form.resetFields();

   }
  }, [success]);

  useEffect (() => {
    getClassList()
   }, []);


  const onFinish = values => {
    console.log('Received values of form: ', values);
    values.category='stationery';
    createStationeryCat(values)
  };
  function handleChange(value) {
    console.log(`selected ${value}`);
  }

  function handleBlur() {
    console.log('blur');
  }

  function handleFocus() {
    console.log('focus');
  }
  
  const [autoCompleteResult, setAutoCompleteResult] = useState([]);

  const onWebsiteChange = value => {
    if (!value) {
      setAutoCompleteResult([]);
    } else {
      setAutoCompleteResult(['.com', '.org', '.net'].map(domain => `${value}${domain}`));
    }
  };

  const websiteOptions = autoCompleteResult.map(website => ({
    label: website,
    value: website,
  }));
  const Option = Select.Option;
  return (
      <div>
    <Card className="gx-card" title="Add Stationery Stock">
    <Form
      {...formItemLayout}
      form={form}
      name="register"
      onFinish={onFinish}
      initialValues={{
        residence: ['zhejiang', 'hangzhou', 'xihu'],
        prefix: '86',
      }}
      scrollToFirstError
    >
     
      
      <Form.Item
        name="name"
        label={
          <span>
          Stationery Name&nbsp;
           
          </span>
        }
        rules={[{ required: true, message: 'Please Stationery!', whitespace: true }]}
      >
        <Input />
        </Form.Item>
      
        <Form.Item
            name="credit"
            placeholder="Number of book"
            label={
              <span>
                Number Of item &nbsp; 
              </span>
            }
            rules={[{ required: true, message: 'Please enter total stock', whitespace: true }]}
      >
       <Input type="number" name="credit" placeholder={'Enter total stock'} />
        </Form.Item>

        {/* <Form.Item
        name="amount"
      
        label={
          <span>
            Amount &nbsp;
           
          </span>
        }
    
      >
        <Input type="number" placeholder={'Amount for per item'} />
        </Form.Item> */}
     
      <Form.Item {...tailFormItemLayout}>
        <Button type="primary" loading={loading} htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
    <NotificationContainer/>
    </Card>
   
  </div>
  );
};

export  default Registration;

